// extracted by mini-css-extract-plugin
module.exports = {"customerBtnWrap":"nav-area_customerBtnWrap_1Yd_2","customerBtn":"nav-area_customerBtn_1_FAz","active":"nav-area_active_ksWRL","corporationText":"nav-area_corporationText_15lw-"};